module.exports = __webpack_public_path__ + "img/exclusive-benefits.b0684b9e.jpg";